import { FormStore, useStoreState } from '@ariakit/react'
import { FC } from 'react'

import {
  B2bLogoAndTextFormValues,
  TextFormValues,
} from '../../../../../../containers/EmbroideryContainer/types'
import { EmbroideryFont } from '../../../../../../containers/EmbroideryContainer/useEmbroideryDesigns'
import { useRestrictedEmbroideryFonts } from '../../../../../../containers/EmbroideryContainer/utils/isEmbroideryColorAllowedForProduct'
import { FontSelector } from '../../../../Modal/primitives/selectors/FontSelector/FontSelector'
import { EmbroideryOptionWrapper } from '../../../../Modal/primitives/shared-form-styles'

interface Props {
  labelId: string
  form: FormStore<TextFormValues | B2bLogoAndTextFormValues>
  fontRestrictions: { key: string }[] | null | undefined
  disabled?: boolean
}
export const Font: FC<Props> = ({ form, fontRestrictions, labelId, disabled }) => {
  const textFonts = useRestrictedEmbroideryFonts(fontRestrictions)

  const font = useStoreState(form, s => s.values.font)
  const errorMessage = useStoreState(form, () =>
    form.getFieldTouched('font') ? form.getError('font') : undefined
  )

  const handleSelectFont = (selectedFont: EmbroideryFont) => form.setValue('font', selectedFont)

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!textFonts) return null
  return (
    <EmbroideryOptionWrapper>
      <FontSelector
        errorMessage={errorMessage ?? undefined}
        labelId={labelId}
        onSelectFont={handleSelectFont}
        selectedFontKey={font?.key}
        fonts={textFonts}
        disabled={disabled}
      />
    </EmbroideryOptionWrapper>
  )
}
